import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { Branch } from 'src/app/services/branch/branch.model';
import { BranchService } from 'src/app/services/branch/branch.service';

@Component({
  selector: 'app-skipped-confirmation',
  templateUrl: './skipped-confirmation.component.html',
  styleUrls: ['./skipped-confirmation.component.scss'],
})
export class SkippedConfirmationComponent implements OnInit, OnDestroy {
  branch: Branch | null = null;

  private subscriptions: Array<Subscription> = [];

  constructor(
    private branchService: BranchService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Eagle Loan | Skipped Confirmation');
    this.branchService.setShowInfoButton(false);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.branchService.selectedBranch.subscribe((data: Branch | null) => {
        this.branch = null;

        if (data) {
          this.branch = { ...data };
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
